import { render } from "./IconCross-b2.w14.h14.vue?vue&type=template&id=93881e76"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__